import { Controller } from "@hotwired/stimulus"
import { clearCircuitPattern, initCircuitPattern } from "../circuit-pattern"

export default class extends Controller {
  static targets = ["icon"]
  static values = { moonSvg: String, sunSvg: String }

  connect() {
    this.applyTheme(this.currentTheme)
  }

  toggle() {
    const newTheme = this.currentTheme === "dark" ? "light" : "dark"
    localStorage.setItem("theme", newTheme)
    this.applyTheme(newTheme)
  }

  applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme)
    this.updateIcon(theme)
    this.redrawCircuitPattern()
  }

  redrawCircuitPattern() {
    clearCircuitPattern()
    initCircuitPattern()
  }

  updateIcon(theme) {
    if (!this.hasIconTarget) return
    this.iconTarget.innerHTML = theme === "dark" ? this.sunSvgValue : this.moonSvgValue
  }

  get currentTheme() {
    return localStorage.getItem("theme") || "light"
  }
}
